import { useDirection } from '@eti/providers';
import { Inline, LinkButton } from '@etg/wings';
import { useHistory } from 'react-router-dom';
import { CaretLeft } from '@phosphor-icons/react';

interface BackToPreviousPageButtonProps {
  dataTestId: string;
  linkText: string;
  route: string;
}

const BackToPreviousPageButton = ({
  dataTestId,
  linkText,
  route,
}: BackToPreviousPageButtonProps) => {
  const history = useHistory();
  const { isRTL } = useDirection();

  return (
    <LinkButton data-testid={dataTestId} onClick={() => history.push(route)}>
      <Inline alignY="center" spacing={4}>
        <CaretLeft mirrored={isRTL} size={20} weight="light" />
        {linkText}
      </Inline>
    </LinkButton>
  );
};

export default BackToPreviousPageButton;
